import { AB_TEST_CONFIGS } from './config/settings'
import type { PatternConfig, AbTestConfig, AbPattern } from './config/types'

// config を引く条件。同じ式が3つの関数に重複していたのをここに寄せた。
// 注意: targetQuery（クエリ条件）はここに入れない。あれは「新規参加の資格」であって
// 「config が有効か」ではない。cookie を読むには config の issueNumber が要るので、
// ここに混ぜると条件のパラメータが無い再訪で config 自体が引けなくなり、
// 割当済みの cookie を読む前に終わる＝参加済みの人が対照群の見た目に戻ってしまう。
const isConfigMatch = (config: AbTestConfig, currentPath: string): boolean =>
    config.isActive && config.pathRegex.test(currentPath)

/**
 * 新規に割当（cookie）を発行してよい流入かの判定（DEV-3390）。
 * 既に cookie を持っている参加者には適用しない（流入 URL から条件のパラメータが
 * 落ちても離脱させないため）。呼び出しは hooks 側で、search 文字列を渡す。
 */
export const isTargetVisitor = (config: AbTestConfig, search: string): boolean => {
    if (!config.targetQuery) return true
    const value = new URLSearchParams(search).get(config.targetQuery.param)
    if (value === null) return false
    return config.targetQuery.pattern.test(value)
}

export const getGtmPrefix = (
    currentPath: string,
    pattern: AbPattern
): string => {
    if (pattern === 'A') return ''

    const activeConfig = AB_TEST_CONFIGS.find((config) =>
        isConfigMatch(config, currentPath)
    )

    if (!activeConfig) return ''

    const hasPattern = activeConfig.patterns.some((p) => p.pattern === pattern)
    if (hasPattern) {
        return `_${activeConfig.issueNumber}_${pattern}`
    }

    return ''
}

export const addGtmPrefix = (
    originalLabel: string,
    currentPath: string,
    pattern: AbPattern
): string => {
    const prefix = getGtmPrefix(currentPath, pattern)
    return prefix ? `${originalLabel}${prefix}` : originalLabel
}

export const isAbTestActive = (currentPath: string): boolean => {
    return AB_TEST_CONFIGS.some((config) => isConfigMatch(config, currentPath))
}

export const getActiveAbTestConfig = (
    currentPath: string
): AbTestConfig | undefined => {
    return AB_TEST_CONFIGS.find((config) => isConfigMatch(config, currentPath))
}

export const validatePercentages = (patterns: PatternConfig[]): boolean => {
    const total = patterns.reduce((sum, pattern) => sum + pattern.percentage, 0)
    return total === 100
}

export const getPatternByPercentage = (
    abValue: number,
    patterns: PatternConfig[]
): AbPattern => {
    if (!validatePercentages(patterns)) {
        const total = patterns.reduce(
            (sum, pattern) => sum + pattern.percentage,
            0
        )
        console.error(
            `ABテスト設定エラー: パーセンテージの合計が100%ではありません (現在: ${total}%)`
        )
        console.error('設定:', patterns)
        return patterns[0].pattern
    }

    let cumulativePercentage = 0
    const scaledValue = (abValue / 10) * 100

    for (const patternConfig of patterns) {
        cumulativePercentage += patternConfig.percentage
        if (scaledValue < cumulativePercentage) {
            return patternConfig.pattern
        }
    }

    return patterns[patterns.length - 1].pattern
}


